import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';

const EstimatePrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '800px',
        height: '1100px',
    };

    const printStyles = `
        @media print {
            body {
                margin: 10px;
            }
        }
    `;

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData[0];

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
            if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };



    return (
        <div style={{ ...containerStyle, padding: '20px' }}>
            <style>{printStyles}</style>
            {firstItem && firstItem.SaleOrderPrint && (
                <div>
                    <h1 style={{ textAlign: 'center', marginBottom: '10px', color: 'blue', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontWeight: 'bold' }}>
                        {firstItem.SaleOrderPrint.CompanyName}
                    </h1>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '-20px' }}>
                        <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                        <h3 style={{ marginLeft: '10px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontWeight: 'bolder', fontSize: '16px' }}>
                            {firstItem.SaleOrderPrint.Address} Pin: {firstItem.SaleOrderPrint.Pincode}
                        </h3>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '-20px' }}>
                        <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                        <h3 style={{ marginLeft: '10px', color: 'black', fontWeight: 'bolder' }}>
                            {firstItem.SaleOrderPrint.CompanyContactNumber}, {firstItem.SaleOrderPrint.CompanyContactNumber2}
                        </h3>
                    </div>

                    <h3 style={{ textAlign: 'center', marginTop: '-20px', fontWeight: 'bolder', fontSize: '18px' }}>
                        GST NO: {firstItem.SaleOrderPrint.GSTNumber}
                    </h3>

                    <hr style={{ border: 'none', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 40px)' }} />

                    <h2 style={{ textAlign: 'center', marginBottom: '10px', fontSize: '20px', fontWeight: 'bold' }}>
                        {firstItem.SaleOrderPrint.IsReprint ? 'TAX INVOICE (Reprinted)' : 'TAX INVOICE'}
                    </h2>

                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Customer:{firstItem.SaleOrderPrint.Name}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Phone No:{firstItem.SaleOrderPrint.ContactNumber}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>GSTNumber No:{firstItem.SaleOrderPrint.CustomerGSTNumber}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Invoice No:{firstItem.SaleOrderPrint.OrderNumber}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Invoice Date: {new Date(firstItem.SaleOrderPrint.OrderDate).toLocaleDateString('en-GB')}</strong>

                    </div>
                </div>
            )}


            {
                firstItem && firstItem.SaleOrderPrintItems && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>Sl No</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>Name</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>HSNCode</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>Qty</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '70px' }}>Rate</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '70px' }}>Taxable Amt</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '30px' }}>GST(%)</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '70px' }}>CGST</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px', width: '70px' }}>SGST</th>
                                <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>Total Amt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {firstItem.SaleOrderPrintItems.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.SerialNo}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.ItemName}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.HSNCODE}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center', fontWeight: 'bold', color: 'black' }}>{item.Quantity}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{item.Rate}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{item.NetAmount}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center', fontWeight: 'bold', color: 'black' }}>{(item.GstRate)}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.CGSTAmount).toFixed(2)}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.SGSTAmount).toFixed(2)}</td>
                                    <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontWeight: 'bold', color: 'black' }}>{(item.TotalAmount).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>

                        <tbody>
                            <tr>
                                {/* Bank Details */}
                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="7">
                                    <table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>BANK   : FEDERAL BANK</th>
                                            </tr>
                                            {/* </thead> */}

                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>BRANCH : ERNAKULAM NORTH</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>A/C NO : 1236598475187</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>IFSC   : FED001</th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </td>

                                {/* Empty Space */}
                                {/* <td style={{ border: '1px solid #000', width: '10px' }} colSpan="3"></td> */}

                                {/* Amount Details */}
                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="2">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>NetValue</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>CGST</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>SGST</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>RoundOff</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>GrandTotal</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>

                                <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.NetAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.CGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.SGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.RoundOff).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.TotalAmount).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>

                            </tr>
                        </tbody>

                    </table>
                )
            }


            {/* {firstItem && firstItem.SaleOrderPrint && (
                <div>
                    <h3 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={firstItem.SaleOrderPrint.TotalAmount}/></h3>

                </div >
            )} */}


        </div >
    );
};

export default EstimatePrint;
